import { useEffect, useState } from 'react'

/**
 * Tracks whether the viewport is narrower than `breakpoint` (default 768px).
 * Shared by the layout shells (AppShell, WorkspaceLayout) so the mobile
 * cutoff lives in exactly one place.
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [mobile, setMobile] = useState(
    typeof window === 'undefined' ? false : window.innerWidth < breakpoint,
  )
  useEffect(() => {
    const onResize = () => setMobile(window.innerWidth < breakpoint)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [breakpoint])
  return mobile
}
